import { useMemo } from "react";
import { useParams } from "react-router-dom";
import ClinicalNote from "src/components/ClinicalNote";
import ExpandedView from "src/components/ExpandedView";
import { MatchParam } from "src/constants/matches";
import { usePatient } from "src/context/PatientProvider";

const ClinicalNotes = () => {
  const patient = usePatient((p) => p);
  const { noteType } = useParams<MatchParam<"NOTE_TYPE">>();

  const type = useMemo(() => {
    if (noteType == null) {
      return "Provider";
    }

    return noteType as "Provider" | "Coordinator";
  }, [noteType]);

  const title = useMemo(() => {
    if (noteType == null) {
      return "PROVIDER";
    }

    return noteType === "Coordinator" ? "HEALTH NAVIGATOR" : "PROVIDER";
  }, [noteType]);

  return (
    <ExpandedView>
      <ClinicalNote
        noteType={type}
        patient={patient}
        maxHeight={"550px"}
        noteTitle={title}
      />
    </ExpandedView>
  );
};

export default ClinicalNotes;
